exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".img-circle {\n  width: 50px;\n  height: 50px; }\n\n.color-white {\n  color: #ffffff; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/taile-operate/BLACK-WIDOW/ng-src/app/module/index-operation/index/index-side/index-side.component.scss
// module id = ../../../../../ng-src/app/module/index-operation/index/index-side/index-side.component.scss
// module chunks = main